import styled from 'styled-components';
export const WrapperReceipt = styled.div`
  .header {
    display: flex;
    align-items: center;
    height: 330px;
    .info {
      width: 40%
    }
  }
  .print-page {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
    row-gap: 50px;
    // width: 21cm;
    // height: 20cm;
    // padding: 0 300px;
    // border: 1px solid;
  }
  .page-container {
    // width: 33.3333%
  }
  .page {
    // position: relative;
    background: white;
    // display: block;
    // margin: 0 auto;
    border: 1px solid black;
    padding: 25px;
    // margin-bottom: 0.5cm;
    // box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
    // width: 5.4cm;
    height: 158px;
  }
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5px;
  }
`;
